import type { EnumUnion } from "@dresscode-frontend/utility-types";

export const PublicIdType = {
  NATIONAL_ID: "NATIONAL_ID",
} as const;

export type PublicIdType = EnumUnion<typeof PublicIdType>;
